// Hero fills the viewport minus the fixed-height blocks that always sit above it
// (measured on https://w9.signnow.com/?hrld=1):
//   mobile  (<768px): sn-app-banner 56 + sn-navbar-type-2 74 + sn-breadcrumbs-type-2 69 (2 rows) = 199
//   desktop (>=768px): sn-navbar-type-2 74 + sn-breadcrumbs-type-2 45 (1 row)                    = 119
// Intentionally static — no JS measuring. Templates can override the custom
// property if a page stacks a different set of blocks above the hero.
$offset-mobile: 199px;
$offset-desktop: 119px;

.sn-hero-header-type-9 {
  --sn-hero-header-type-9-offset: #{$offset-mobile};

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100dvh - var(--sn-hero-header-type-9-offset));
  overflow: hidden;
  color: $color-neutral-white;
  text-align: center;
  margin-bottom: $spacing-3xl;

  @include desktop {
    --sn-hero-header-type-9-offset: #{$offset-desktop};
  }

  @include desktop-lg {
    margin-bottom: $spacing-6xl;
  }

  &::after {
    background-color: rgb(23 30 51 / 70%);
    inset: 0;
    content: "";
    display: block;
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: 1;
  }

  &__background {
    left: calc(50% - 50vw);
    margin-top: 14px;
    max-height: 100vh;
    overflow: hidden;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100vw;
    z-index: 0;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    @include desktop {
      left: calc(50% - 384.5px);
      margin-top: 0;
      max-height: none;
      overflow: visible;
      top: 0;
      transform: none;
      width: 769px;
    }
  }

  &__background-img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  &__content {
    position: relative;
    z-index: 2;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 720px;
    padding: 0 map-get($spacings, xl) map-get($spacings, 3xl);

    @include desktop {
      padding: 0 map-get($spacings, 2xl) map-get($spacings, 5xl);
    }
  }

  &__heading {
    font-size: map-get($font-sizes, 4xl);
    font-family: $sn-font-family-heading;
    font-weight: map-get($font-weights, bold);
    line-height: map-get($line-heights, 2xl);
    color: $color-neutral-white;
    margin: 0 0 map-get($spacings, lg);

    @include desktop {
      font-size: map-get($font-sizes, 6xl);
    }
  }

  &__description {
    font-size: map-get($font-sizes, xl);
    line-height: map-get($line-heights, lg);
    color: $color-neutral-neutral-lighter;
    margin: 0 0 map-get($spacings, 2xl);
    max-width: 600px;
  }

  &__cta {
    min-width: 214px;
  }

  // Intro button: 214×48, same box as sn-hero-header-type-2. The theme rule
  // `body.signnow [data-color-mode] .me-button--primary` (0,3,1) outranks three classes,
  // so the `[data-color-mode]` ancestor lifts this to (0,4,0) and the padding sticks.
  [data-color-mode] &__cta.me-button.me-button--primary {
    padding: 0.625rem 1.2rem;
  }
}
